<div class="loading" *ngIf="isLoading">
  <div class="loading__icon">
    <svg-icon name="spinner" class="spinner"></svg-icon>
  </div>
</div>

<ng-container *ngIf="product">
  <div *ngIf="product.administration_flag" class="preview__outer">
    <div class="preview">
      This is administrative preview.<br />
      The competition starts
      {{ product.start_at | unifyDate | tzDate: 'MMM d, HH:mm' }}.
    </div>
  </div>

  <app-header-alert
    *ngIf="headerAlertData"
    [data]="headerAlertData"
  ></app-header-alert>
  <main class="product">
    <section>
      <div class="container">
        <div #root>
          <div class="alert alert_error alert_mt" *ngIf="errorMessageTop">
            <div class="alert__text">{{ errorMessageTop }}</div>
          </div>
        </div>

        <div class="product__details">
          <div>
            <app-product-gallery
              [items]="galleryProductItems"
              [textCover]="product.is_open ? galleryCoverText : null"
              [redCover]="
                !product.is_open
                  ? product.current_entries >= product.max_entries
                    ? 'Sold Out!'
                    : 'Competition Closed'
                  : null
              "
            ></app-product-gallery>
          </div>
          <div #mobileStickyTriggerElement>
            <div class="product__details-content">
              <app-raffle-instant-logo
                [instantType]="product.instant_win_type"
                *ngIf="isInstantWin"
              ></app-raffle-instant-logo>

              <app-countdown
                *ngIf="showCountdown"
                [type]="'single'"
                [expiredAt]="product?.end_at"
                (onExpired)="onExpired($event)"
                [class.countdown-iw]="isInstantWin"
              ></app-countdown>

              <div
                class="product__title"
                [ngClass]="{ 'product__title--reset-margin': isInstantWin }"
              >
                {{ product?.title }}
              </div>
              <div class="product__subtitle" *ngIf="product.subtitle">
                {{ product.subtitle }}
              </div>
              <div class="product__subtitle" *ngIf="product.cash_alternative">
                Cash Alternative:
                {{
                  product.cash_alternative | currency: 'GBP' : 'symbol' : '1.0'
                }}
              </div>

              <div class="product__drawtime-container">
                <div
                  class="product__drawtime product__drawtime--urgent"
                  *ngIf="drawTimeVersion === 'today'"
                >
                  {{ badgeLabel }} Today
                  {{ badgeDate | unifyDate | tzDate: 'ha' | lowercase }}
                  {{ badgeDate | ukTimezone }}
                </div>
                <div
                  class="product__drawtime product__drawtime--urgent"
                  *ngIf="drawTimeVersion === 'tomorrow'"
                >
                  {{ badgeLabel }} Tomorrow
                  {{ badgeDate | unifyDate | tzDate: 'ha' | lowercase }}
                  {{ badgeDate | ukTimezone }}
                </div>
                <div
                  class="product__drawtime"
                  *ngIf="drawTimeVersion === 'thisweek'"
                >
                  {{ badgeLabel }} {{ badgeDate | unifyDate | tzDate: 'EEEE' }}
                  {{ badgeDate | unifyDate | tzDate: 'ha' | lowercase }}
                  {{ badgeDate | ukTimezone }}
                </div>
                <div
                  class="product__drawtime"
                  *ngIf="drawTimeVersion === 'launched'"
                >
                  Just launched</div
                >

                <div
                  class="product__drawtime product__drawtime--soon"
                  *ngIf="installAppMode"
                  >App Exclusive</div
                >
                <div
                  class="product__drawtime product__drawtime--soon"
                  *ngIf="openBrowserMode"
                  >Only in browser</div
                >
                <div
                  class="product__drawtime product__drawtime--blue-border"
                  *ngIf="
                    product.draw_method === 'auto' && !product.is_without_draw
                  "
                  >Automated Draw</div
                >
              </div>

              <app-product-conditions
                [product]="product"
                [currency]="currency"
                *ngIf="isInstantWin"
              ></app-product-conditions>
              <div
                class="product__price"
                [ngClass]="{ 'product__price-new': oldPrice }"
              >
                <span class="product__price-old" *ngIf="oldPrice">
                  {{ oldPrice | currency: currency }}
                </span>
                {{ price | currency: currency }}
              </div>

              <div
                class="product__discount-timer"
                *ngIf="showDiscountTimer && product.is_open"
              >
                <div class="product__discount-label">Discount ends in</div>
                <div class="product__discount-clock"
                  >&nbsp;{{ discountTimerString }}</div
                >
              </div>

              <ng-container *ngIf="product.max_entries && !product.is_cash">
                <div class="product__sold text-left">
                  SOLD: {{ sliderValue }}%
                </div>
                <div class="product__slider">
                  <div class="product__slider--track">
                    <span
                      class="product__slider--track-fill"
                      [ngStyle]="{ width: sliderValue + '%' }"
                    ></span>
                  </div>

                  <div class="product__slider-label">
                    {{ product.current_entries | number }} /
                    {{ product.max_entries | number }}
                  </div>
                </div>
              </ng-container>
            </div>
            <app-product-tickets
              class="product__details-tickets"
              [product]="product"
              [activeEntryOption]="activeEntryOption"
              [closedRaffle]="closedRaffle"
              [formGroup]="formGroup"
              [isAddingToCart]="isAddingToCart"
              [isTooMuchTicketPerUser]="isTooMuchTicketPerUser"
              [errorMessage]="errorMessage"
              [sliderMaxTickets]="sliderMaxTickets"
              [sliderMinTickets]="sliderMinTickets"
              [entranceAvailable]="entranceAvailable"
              [sliderTicketQuantity]="sliderTicketQuantity"
              [projectCode]="projectCode"
              [dialog]="dialog"
              [addedTickets]="addedTickets"
              [productPageText]="productPageText"
              [tokenizedCards]="tokenizedCards"
              [installAppMode]="installAppMode"
              [openBrowserMode]="openBrowserMode"
              [trustpilotConfig]="trustpilotConfig"
              [isInstantWin]="isInstantWin"
              (emitHandleSubmit)="handleSubmit()"
              (handleInstantCheckoutEmitter)="handleInstantCheckout()"
              (fillProductTickerProductPageFunction)="
                fillProductTickerProductPageFunction($event)
              "
            ></app-product-tickets>
          </div>
        </div>
      </div>
    </section>
    <!-- Rating -->
    <section class="product__rating" *ngIf="isInstantWin">
      <div class="container">
        <app-product-close-details
          [trustpilotConfig]="trustpilotConfig"
          [endAt]="product.end_at"
          [instantTypeText]="productPageText.productCloseText"
        ></app-product-close-details>
      </div>
    </section>
    <!-- Conditions -->
    <section class="product__conditions" *ngIf="product && !isInstantWin">
      <div class="container">
        <div class="product__condition">
          <svg-icon name="entry" fill="none"></svg-icon>
          <span>Entries only {{ price | currency: currency }}</span>
        </div>

        <div
          class="product__condition"
          *ngIf="product.max_entries && !product.is_cash"
        >
          <svg-icon name="maximize"></svg-icon>
          <span>Max entries {{ product.max_entries | number: '1.0-0' }}</span>
        </div>

        <div class="product__condition" *ngIf="product.instant_win_count > 0">
          <svg-icon name="total-value" fill="none"></svg-icon>
          <span
            >Total value {{ product.prize_value | currency: currency }}</span
          >
        </div>

        <div class="product__condition" *ngIf="product.ticket_limit_per_user">
          <svg-icon name="avatar"></svg-icon>
          <span
            >Max {{ product.ticket_limit_per_user | number: '1.0-0' }} per
            person</span
          >
        </div>

        <div
          class="product__condition product__condition--gray"
          *ngIf="geoVersion === 'world'"
        >
          <svg-icon name="world-stroke" fill="none" stroke="#939ca4"></svg-icon>
          <span>
            Worldwide shipping
            <svg-icon
              (click)="openWorldwideDialog()"
              name="info-icon"
              fill="none"
            ></svg-icon>
          </span>
        </div>

        <div class="product__condition" *ngIf="product.instant_win_count > 0">
          <svg-icon name="total-prise" fill="none"></svg-icon>
          <span
            >Total prizes
            {{
              product.instant_win_count + product.prize_count | number: '1.0-0'
            }}</span
          >
        </div>
      </div>
    </section>
    <!-- Draw result -->
    <section
      class="product__draw-result"
      *ngIf="!product.is_without_draw && !isInstantWin"
    >
      <div class="container">
        <ng-container *ngTemplateOutlet="drawResult"></ng-container>
      </div>
    </section>
    <!-- IW How it works -->

    <app-product-how-works
      *ngIf="
        !(hasBoughtIT$ | async)?.includes(product.instant_win_type) &&
        isInstantWin
      "
      [instantType]="product.instant_win_type"
    ></app-product-how-works>
    <!-- IW end prize -->
    <div
      class="product__end-prize"
      [ngClass]="{
        'product__end-prize--white': (hasBoughtIT$ | async)?.includes(
          product.instant_win_type
        )
      }"
      *ngIf="
        isInstantWin && (product.end_prize_short_name || product.end_prize_name)
      "
    >
      <app-product-end-prize
        [endPrize]="product.end_prize_short_name || product.end_prize_name"
        [endAt]="product.result_at"
        [endPrizeDescription]="productPageText.productEndPrizeDescription"
        [endPrizeInfo]="productPageText.productEndPrizeInfo"
        [drawMethod]="product.draw_method"
        [facebookUrl]="facebookUrl"
        [youtubeUrl]="youtubeUrl"
        (infoEvent)="openAutodrawDialog()"
      ></app-product-end-prize>
    </div>

    <div id="navigation-wrapper" class="navigation-wrapper">
      <!-- Sticky nav -->
      <app-sticky-nav
        [items]="sectionsNavItems"
        [buttons]="sectionsNavButtons"
        [type]="'item'"
      ></app-sticky-nav>
      <div
        *ngIf="showMobileStickyBar"
        class="product__sticky-mobile"
        [class.product__sticky-mobile--small]="
          projectCode === projectCodes.UKCC
        "
        [class.product__sticky-mobile--native]="isNativeAppVisible"
        [class.product__sticky-mobile--native-ukcc]="
          isNativeAppVisible && projectCode === projectCodes.UKCC
        "
        id="mobile-sticky-bar"
      >
        <button
          class="button button_no-shadow"
          (click)="showModalProductTickets(true)"
          (touchend)="showModalProductTickets(true)"
        >
          {{ productPageText.sectionsNavButton }}
          <svg-icon
            name="ticket-small"
            class="product__sticky-mobile--icon"
          ></svg-icon>
        </button>
      </div>
      <!-- Prizes -->
      <section
        class="product__prizes"
        *ngIf="product.instant_win_count > 0"
        id="instant-win-section"
      >
        <div
          class="container"
          [class.product__prizes-shadow]="
            instantWinGroup?.length > instantWinGroupLimit
          "
        >
          <h3 class="product__section-title">Prizes</h3>
          <ng-container *ngIf="instantWinGroup?.length > 0">
            <div
              class="product__prize"
              *ngFor="
                let group of instantWinGroup | slice: 0 : instantWinGroupLimit
              "
            >
              <app-prize-card
                [group]="group"
                [closeCard]="closeAllCard"
              ></app-prize-card>
            </div>
            <button
              type="button"
              id="how-more-btn"
              class="product__prize-btn"
              *ngIf="instantWinGroupLimit < instantWinGroup?.length"
              (click)="showLessBtn()"
              >See more</button
            >
            <button
              type="button"
              class="product__prize-btn"
              *ngIf="showLessInstantWinGroup && isActiveLessBtn"
              (click)="hideLessBtn()"
              >Show less</button
            >
            <div
              class="product__prize-less-more"
              [@showLess]="stickyLessInstantWinGroup ? 'out' : 'in'"
            >
              <button
                type="button"
                class="product__prize-btn"
                (click)="hideLessBtn()"
                >Show less</button
              >
            </div>
          </ng-container>

          <div *ngIf="isLoadingInstantWinGroup" class="loader-icon__box">
            <svg-icon
              name="circle-notch"
              [spin]="true"
              class="loader-icon__icon"
            ></svg-icon>
          </div>
        </div>
      </section>
      <!-- Competition Details -->
      <section
        class="product__competition-details"
        id="competition-details-section"
      >
        <div class="container">
          <h3 class="product__section-title">Competition Details</h3>
          <div class="stream_video" *ngIf="videoUrl">
            <app-videojs
              [mediaId]="videoId"
              [videoUrl]="videoUrl"
            ></app-videojs>
          </div>
          <article [innerHtml]="product.description | safeHtml"></article>
        </div>
      </section>
      <section id="faq-section" class="product__faq">
        <div class="container">
          <h3 class="product__section-title">FAQ</h3>
          <app-faq
            [faqList]="faqItems"
            [isShowArrow]="true"
            [isOpenFirstQA]="false"
          ></app-faq>
        </div>
      </section>
      <!-- Share -->
      <section class="product__share">
        <div class="container">
          <div class="product__share-label"> Share this </div>
          <div class="product__share-icons">
            <share-buttons
              [theme]="'default sharebuttons-p7d'"
              [show]="6"
              [include]="shareOptions"
              [showText]="true"
              [url]="currentUrl"
            ></share-buttons>
          </div>
        </div>
      </section>
      <!-- Payments -->
      <section class="product__payments">
        <div class="container">
          <app-payment-systems [noPadding]="true"></app-payment-systems>
        </div>
      </section>
    </div>
  </main>
</ng-container>

<div #scrollbarMeasure class="modal-scrollbar-measure"></div>

<app-not-found *ngIf="hasError404"></app-not-found>

<ng-template #closedRaffle>
  <div class="closed-raffle">
    <aside class="alert alert_warn">
      <p class="alert__text" *ngIf="!product.is_without_draw">
        <ng-container *ngIf="product.draw_method === 'live'">
          This competition has now closed, please wait for the live draw on our
          Facebook page.
        </ng-container>
        <ng-container *ngIf="product.draw_method === 'auto'">
          The competition has now closed and the winner will be contacted.
        </ng-container>
      </p>
      <p class="alert__text" *ngIf="product.is_without_draw">
        {{ closedRaffleInstantWinMessage }}
      </p>
    </aside>
  </div>
</ng-template>

<ng-template #drawResult>
  <div
    class="product__draw-result-title"
    [class.product__draw-result-title--auto]="product.draw_method === 'auto'"
  >
    <strong>
      {{ product.draw_method === 'auto' ? 'Automated' : 'Live' }} Draw
      <svg-icon
        (click)="openAutodrawDialog()"
        name="info-icon"
        fill="none"
        *ngIf="product.draw_method === 'auto'"
      ></svg-icon>
    </strong>
    <span>
      {{ product.result_at | unifyDate | tzDate: 'dd-MM-yyyy @ h:mmaaa' }}
      {{ badgeDate | ukTimezone }}</span
    >
  </div>
  <ul>
    <li> Draw takes place regardless of sell out </li>
    <li> Competition will close sooner if the maximum entries are received </li>
    <li *ngIf="product.draw_method === 'live'">
      Interactive live draw on our
      <a [href]="facebookUrl" target="_blank">Facebook</a>
      <ng-container *ngIf="youtubeUrl">
        and <a [href]="youtubeUrl" target="_blank">Youtube</a>
      </ng-container>
      page
    </li>
  </ul>
</ng-template>

@if (modalRepeatPurchaseShow) {
  <app-modal-repeat-purchase
    [rafflesReveals]="[raffleOrder]"
    [rafflesInput]="[product]"
    [projectCode]="projectCode"
    [modalShow]="modalRepeatPurchaseShow"
    (toggleModal)="modalRepeatPurchaseShow = false"
    (emitPopulateCartOnClose)="handlePopulateCartOnClose($event)"
  ></app-modal-repeat-purchase>
}
@if (modalProductTicketsShow) {
  <div
    @inOutOpacity
    ngClass="overlay"
    (click)="hideModalProductTickets()"
  ></div>
  <app-product-tickets
    [@inOutRightAnimation]="animationState"
    class="modal-product-tickets"
    [product]="product"
    [closedRaffle]="closedRaffle"
    [activeEntryOption]="activeEntryOption"
    [formGroup]="formGroup"
    [isAddingToCart]="isAddingToCart"
    [isTooMuchTicketPerUser]="isTooMuchTicketPerUser"
    [errorMessage]="errorMessage"
    [sliderMaxTickets]="sliderMaxTickets"
    [sliderMinTickets]="sliderMinTickets"
    [entranceAvailable]="entranceAvailable"
    [sliderTicketQuantity]="sliderTicketQuantity"
    [projectCode]="projectCode"
    [dialog]="dialog"
    [addedTickets]="addedTickets"
    [productPageText]="productPageText"
    [isModalShown]="true"
    [tokenizedCards]="tokenizedCards"
    [installAppMode]="installAppMode"
    [openBrowserMode]="openBrowserMode"
    [isInstantWin]="isInstantWin"
    (emitHandleSubmit)="handleSubmit()"
    (emitModalToggleEmitter)="hideModalProductTickets()"
    (handleInstantCheckoutEmitter)="handleInstantCheckout()"
    (handleQuantityChange)="handleQuantityChangeFromModal($event)"
  ></app-product-tickets>
}
